export default "__VITE_ASSET__C4M5pJbd__"